import React, { Component } from "react";
import { Form, Input, InputNumber, Select, Button, Checkbox } from "antd";

//data
import { countries, states, distances, recruitmentOptions } from "../../data";

const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;

var typing = null;

const PatientInfoForm = Form.create()(
  class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        data: [],
        conditionTyping: false
      };
    }
    renderCountryOptions = () => {
      return countries.map(country => {
        return (
          <Option key={country.code} value={country.code}>
            {country.name}
          </Option>
        );
      });
    };
    renderStateOptions = () => {
      return states.map(state => {
        return (
          <Option key={state.code} value={state.code}>
            {state.name}
          </Option>
        );
      });
    };
    renderDistanceOptions = () => {
      return distances.map(distance => {
        return (
          <Option key={distance.code} value={distance.value}>
            {distance.value === 10000
              ? "Any Distance"
              : `${distance.value} Miles`}
          </Option>
        );
      });
    };
    renderDistanceField = (getFieldDecorator, isUS) => {
      return (
        <div>
          <FormItem label="Distance">
            {getFieldDecorator("clinicalTrialsDistance", {
              rules: []
            })(
              <Select placeholder="Select a distance">
                {this.renderDistanceOptions()}
              </Select>
            )}
          </FormItem>
          {isUS ? (
            <FormItem label="States willing to travel to">
              {getFieldDecorator("clinicalTrialsExtraStates", {
                rules: []
              })(
                <Select
                  mode="tags"
                  maxTagCount={3}
                  placeholder="Select states (max of 3)"
                  optionFilterProp="children"
                  onChange={value => {
                    if (value.length > 3) value = value.shift();
                  }}
                  filterOption={(input, option) => {
                    const currentIndex = input.length;
                    if (
                      option.props.children
                        .substring(0, currentIndex)
                        .toLowerCase() === input.toLowerCase()
                    )
                      return true;
                  }}
                >
                  {this.renderStateOptions()}
                </Select>
              )}
            </FormItem>
          ) : null}
        </div>
      );
    };
    renderCityField = getFieldDecorator => {
      return (
        <FormItem label="City">
          {getFieldDecorator("clinicalTrialsCity", {
            rules: []
          })(<Input />)}
        </FormItem>
      );
    };
    renderLocationFields = (country, getFieldDecorator) => {
      var isUS = false;
      switch (country) {
        case "US":
          isUS = true;
          return (
            <div>
              <FormItem label="State">
                {getFieldDecorator("clinicalTrialsState", {
                  rules: []
                })(
                  <Select
                    showSearch
                    placeholder="Select a state"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      const currentIndex = input.length;
                      if (
                        option.props.children
                          .substring(0, currentIndex)
                          .toLowerCase() === input.toLowerCase()
                      )
                        return true;
                    }}
                  >
                    {this.renderStateOptions()}
                  </Select>
                )}
              </FormItem>
              {this.renderCityField(getFieldDecorator)}
              {this.renderDistanceField(getFieldDecorator, isUS)}
            </div>
          );
        case undefined:
          return null;
        default:
          return (
            <div>
              {this.renderCityField(getFieldDecorator)}
              {this.renderDistanceField(getFieldDecorator, isUS)}
            </div>
          );
      }
    };

    componentDidUpdate(prevProps, prevState) {
      const { isNew, fetchingValues } = this.props;
      if (!isNew && prevProps.fetchingValues && !fetchingValues)
        this.updateFormFields();
      if (prevState.conditionTyping && !this.state.conditionTyping) {
        var myUrl = `https://clinicaltrials.gov/beta/rpc/extend/cond?cond=${
          this.state.conditionValue
        }`;
        //  But if you make it from a browser, then it will work without problem ...

        // However to make it work, we are going to use the cors-anywhere free service to bypass this
        var proxy = "https://cors-anywhere.herokuapp.com/";

        // Execute request
        var oReq = new XMLHttpRequest();

        oReq.onreadystatechange = () => {
          if (oReq.readyState === 4) {
            this.setState({ data: oReq.response });
          }
        };
        // Or post, etc
        oReq.responseType = "json";
        oReq.open("GET", proxy + myUrl, true);
        oReq.send();
      }
    }

    updateFormFields = () => {
      const {
        clinicalTrialsCondition,
        clinicalTrialsAge,
        clinicalTrialsGender,
        clinicalTrialsCountry,
        clinicalTrialsState,
        clinicalTrialsCity,
        clinicalTrialsDistance,
        clinicalTrialsExtraStates,
        clinicalTrialsStudyStatus
      } = this.props.existingValues;
      this.props.form.setFields({
        clinicalTrialsCondition: { value: clinicalTrialsCondition },
        clinicalTrialsAge: { value: clinicalTrialsAge },
        clinicalTrialsGender: { value: clinicalTrialsGender },
        clinicalTrialsCountry: { value: clinicalTrialsCountry },
        clinicalTrialsStudyStatus: { value: clinicalTrialsStudyStatus }
      });
      setTimeout(() => {
        if (clinicalTrialsCountry === "US")
          this.props.form.setFields({
            clinicalTrialsState: { value: clinicalTrialsState },
            clinicalTrialsCity: { value: clinicalTrialsCity },
            clinicalTrialsDistance: { value: clinicalTrialsDistance },
            clinicalTrialsExtraStates: {
              value: clinicalTrialsExtraStates
            }
          });
        else
          this.props.form.setFields({
            clinicalTrialsCity: { value: clinicalTrialsCity },
            clinicalTrialsDistance: { value: clinicalTrialsDistance }
          });
      }, 100);
    };

    onChangeCondition = value => {
      this.setState({ conditionTyping: true, conditionValue: value });
      if (typing != null) {
        clearTimeout(typing);
        typing = null;
      } else {
        typing = setTimeout(() => {
          this.setState({ conditionTyping: false });
        }, 200);
      }
    };

    render() {
      const { handleSubmit, form, loading } = this.props;
      const { getFieldDecorator } = form;
      const country = form.getFieldValue("clinicalTrialsCountry");
      const options = this.state.data.map(d => <Option key={d}>{d}</Option>);
      return (
        <Form onSubmit={e => handleSubmit(e, form)}>
          <FormItem label="Condition or disease">
            {getFieldDecorator("clinicalTrialsCondition", {
              rules: []
            })(
              <Select
                showSearch
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={this.onChangeCondition}
                notFoundContent={null}
              >
                {options}
              </Select>
            )}
          </FormItem>
          <FormItem
            label="Age"
            style={{ display: "inline-block", width: "35%" }}
          >
            {getFieldDecorator("clinicalTrialsAge", {
              rules: []
            })(<InputNumber min={0} max={120} style={{ width: "90%" }} />)}
          </FormItem>
          <FormItem
            label="Gender"
            style={{ display: "inline-block", width: "65%" }}
          >
            {getFieldDecorator("clinicalTrialsGender", {
              rules: []
            })(
              <Select placeholder="Select a gender">
                <Option value="Male">Male</Option>
                <Option value="Female">Female</Option>
                <Option value="All">Other</Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="Country">
            {getFieldDecorator("clinicalTrialsCountry", {
              rules: []
            })(
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const currentIndex = input.length;
                  if (
                    option.props.children
                      .substring(0, currentIndex)
                      .toLowerCase() === input.toLowerCase()
                  )
                    return true;
                }}
              >
                {this.renderCountryOptions()}
              </Select>
            )}
          </FormItem>
          {this.renderLocationFields(country, getFieldDecorator)}
          <FormItem label="Reports">
            {getFieldDecorator("includePubMed", {
              rules: []
            })(<Checkbox>Include PubMed Reports</Checkbox>)}
          </FormItem>
          <FormItem style={{ marginTop: -33 }}>
            {getFieldDecorator("includePremedline", {
              rules: []
            })(<Checkbox>Include Premedline Reports</Checkbox>)}
          </FormItem>
          <FormItem label="Study Type">
            {getFieldDecorator("clinicalTrialsStudyType", {
              rules: []
            })(
              <Select placeholder="Select a type">
                <Option value="Obsr">Observational</Option>
                <Option value="Intr">Interventional</Option>
                <Option value="All">All</Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="Recruitment status">
            {getFieldDecorator("clinicalTrialsStudyStatus", {
              rules: []
            })(
              <CheckboxGroup options={recruitmentOptions} defaultValue={[]} />
            )}
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
            >
              Get New Results
            </Button>
          </FormItem>
        </Form>
      );
    }
  }
);

export { PatientInfoForm };



// WEBPACK FOOTER //
// ./src/components/forms/PatientInfoForm.js